import React, { useState, useEffect, useRef, useContext } from "react";
import HeaderDetails from "../../components/header/header_details";
import DataDetails from "../home/data-details/data-details";
import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { MenuContext } from "../../views/dashboard/admin/admin"; 

function Detalles() {
  const handleMenuClick = useContext(MenuContext);
  const [collapsed, setCollapsed] = useState(true);
  const [collapsed2, setCollapsed2] = useState(true);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [totales, setTotales] = useState([]);
  const [year, setYear] = useState(true);
  const [week, setWeek] = useState(true);
  const [detail, setDetail] = useState(true);
  const [Estaciones, setEstaciones] = useState(true);
  const [MexDom, setMexDom] = useState(true);
  const [MexExpo, setMexExpo] = useState(true);
  const [Impo, setImpo] = useState(true);
  const [VuelosFacturadosVar, setVuelosFacturados] = useState(true);
  const [query, setQuery] = useState(window.location.search);
  
  // --- ESTADOS DE PAGINACIÓN ---
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const containerRef = useRef(null);

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  // 1. Manejador de Scroll (Paginador)
  const handleScroll = () => {
    if (containerRef.current) {
      const { scrollTop, clientHeight, scrollHeight } = containerRef.current;
      // Si llegamos al final del scroll y no estamos cargando, pedimos la siguiente página
      if (scrollTop + clientHeight >= scrollHeight - 5 && hasMore && !loading) {
        setPage((prevPage) => prevPage + 1);
      }
    }
  };

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, [hasMore, loading]);

  const toggleCollapse2 = () => {
    setCollapsed2(!collapsed2);
  };

  const getDashboard = async (isFirstLoad = false) => {
    try {
      setLoading(true);
      const searchParams = new URLSearchParams(window.location.search);
      const r_week = searchParams.get("week");
      const r_year = searchParams.get("year");
      const r_detail = searchParams.get("detail");

      if (r_week && r_year) {
        setYear(r_year);
        setWeek(r_week);
        setDetail(r_detail);
        
        const url = `${process.env.REACT_APP_URL_BACKEND}/dashboard/details`;
        const res = await axios.post(url, {
          params: {
            week: r_week,
            year: r_year,
            detail: r_detail,
            page: isFirstLoad ? 1 : page, // Usar página 1 si es cambio de URL
            limit: 500,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (res.data.code === 1) {
          if (res.data.results.length > 0) {
            // Si es carga inicial por URL limpia datos, si no, concatena
            setData((prevData) => isFirstLoad ? res.data.results : [...prevData, ...res.data.results]);
            setTotales(res.data.totales_semanas);
            
            // Si vinieron menos de 500 registros, ya no hay más
            if (res.data.results.length < 500) {
                setHasMore(false);
            }
          } else {
            setHasMore(false);
          }
        }
      }
      setLoading(false);
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
      setLoading(false);
    }
  };

  // Efecto cuando cambia la página (Scroll)
  useEffect(() => {
    if (page > 1) {
      getDashboard(false);
    }
  }, [page]);

  // Efecto cuando cambia la URL (Reset total del paginador)
  useEffect(() => {
    setPage(1);
    setHasMore(true);
    getDashboard(true);
    setQuery(window.location.search);
  }, [window.location.search]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setCollapsed(true);
        setCollapsed2(true);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Lógica de pintado de tabla respetando tu funcionamiento original
  useEffect(() => {
    const tbody = document.getElementById("main-data");
    if (!tbody) return;

    // Solo limpiamos el HTML si es la página 1 (nueva consulta)
    if (page === 1) tbody.innerHTML = "";
    
    // Solo agregamos los nuevos datos (evita repintar todo el DOM cada vez)
    // Para respetar tu lógica de "pedro" (el contador de filas), usamos el índice del array data
    if (data.length > 0) {
      tbody.innerHTML = ""; // En este caso particular, como usas un useEffect dependiente de [data], repintamos
      
      data.forEach((row, index) => {
        const tr = document.createElement("tr");

        const tdId = document.createElement("td");
        tdId.textContent = index + 1;
        tr.appendChild(tdId);

        const td0 = document.createElement("td");
        td0.textContent = row.folio_fiscal;
        tr.appendChild(td0);

        const td1 = document.createElement("td");
        td1.textContent = row.concepto;
        tr.appendChild(td1);

        const td2 = document.createElement("td");
        td2.textContent = row.clave;
        tr.appendChild(td2);

        const td3 = document.createElement("td");
        td3.textContent = row.anio;
        tr.appendChild(td3);

        const td4 = document.createElement("td");
        td4.textContent = row.semana;
        tr.appendChild(td4);

        const td5 = document.createElement("td");
        td5.textContent = row.tiempo_demora;
        tr.appendChild(td5);

        const td6 = document.createElement("td");
        td6.textContent = row.emisor || "AMC";
        tr.appendChild(td6);

        const td7 = document.createElement("td");
        td7.textContent = row.origen;
        tr.appendChild(td7);

        const td8 = document.createElement("td");
        td8.textContent = row.destino;
        tr.appendChild(td8);

        const td9 = document.createElement("td");
        td9.textContent = row.guias;
        tr.appendChild(td9);

        const td10 = document.createElement("td");
        td10.textContent = row.importe_mx;
        tr.appendChild(td10);

        const td11 = document.createElement("td");
        td11.textContent = row.kgsFact;
        tr.appendChild(td11);

        const td12 = document.createElement("td");
        td12.textContent = row.tarifa || "-";
        tr.appendChild(td12);

        tbody.appendChild(tr);
      });

      if(totales && totales.length > 0){
          setEstaciones(totales[0].sem_actual_estaciones_este_vuelo || 0);
          setMexDom(totales[0].sem_actual_mex_dom_esta_semana || 0);
          setMexExpo(totales[0].sem_actual_mex_expo_esta_semana || 0);
          setImpo(totales[0].sem_actual_impo_esta_semana || 0);
          setVuelosFacturados(totales[0].vuelos_sem_actual_facturados_esta_semana || 0);
      }
    }
  }, [data, totales]);

  const exportToExcel = () => {
    const mainTable = document.getElementById("main-table");
    const wsMain = XLSX.utils.table_to_sheet(mainTable);
    const secondaryTable = document.getElementById("secondary-table");
    const wsSecondary = XLSX.utils.table_to_sheet(secondaryTable);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsMain, "Vuelos Operados");
    XLSX.utils.book_append_sheet(wb, wsSecondary, "Totales");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
    const buffer = new ArrayBuffer(wbout.length);
    const view = new Uint8Array(buffer);
    for (let i = 0; i < wbout.length; i++) {
      view[i] = wbout.charCodeAt(i) & 0xff;
    }
    const fileName = "vuelos_operados.xlsx";
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    saveAs(blob, fileName);
  };

  return (
    <div className="main-section">
      <div className="row mt-4 px-4">
        <div className="col-12 d-flex align-items-end justify-content-center mt-2">
          <p className="">
            <b>Detalles {loading && "(Cargando...)"}</b>
          </p>
        </div>
        <div className="col-12 d-flex align-items-end justify-content-end mb-3">
          <span className={`d-flex text-decoration-none justify-content-around blue-pill`} onClick={exportToExcel} style={{cursor: 'pointer'}}>
            <div>
              <p className="fs-11 mt-2 mb-2 me-3 ms-3">Exportar</p>
            </div>
          </span>
        </div>
        
        {/* Tabla secundaria (Totales) */}
        <div className={`col-md-2 fs-10 ${collapsed ? "" : "d-none"}`}>
          <table className="table table-hover" id="secondary-table">
            <thead>
              <tr className="bg-color-gray">
                <th className="bg-color-gray text-white">Semana</th>
                <th className="bg-color-gray text-white">Concepto</th>
                <th className="bg-color-gray text-white">Total</th>
              </tr>
            </thead>
            <tbody className="text-center">
              <tr className="bg-color-gray">
                <td rowSpan="6"> {year % 10} {week} </td>
                <td>Estaciones</td>
                <td>{Estaciones}</td>
              </tr>
              <tr className="bg-color-gray">
                <td>Mex Dom</td>
                <td>{MexDom}</td>
              </tr>
              <tr className="bg-color-gray">
                <td>Mex Expo</td>
                <td>{MexExpo}</td>
              </tr>
              <tr className="bg-color-gray">
                <td>Impo</td>
                <td>{Impo}</td>
              </tr>
              <tr className="bg-color-gray">
                <td>Vuelos Facturados</td>
                <td>{VuelosFacturadosVar}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Tabla principal con Scroll Paginador */}
        <div
          className={`col-md-10 fs-10 table-responsive ${collapsed2 ? "" : "d-none"}`}
          ref={containerRef}
          style={{ maxHeight: "600px", overflowY: "auto" }} // Estilo necesario para detectar el scroll
        >
          <table className="table table-hover" id="main-table">
            <thead>
              <tr>
                <th className="bg-color-softblue text-white rounded-table-left">#</th>
                <th className="bg-color-softblue text-white">Folio Fiscal</th>
                <th className="bg-color-softblue text-white">Concepto</th>
                <th className="bg-color-softblue text-white">Clave</th>
                <th className="bg-color-softblue text-white">Año</th>
                <th className="bg-color-softblue text-white">Semana</th>
                <th className="bg-color-softblue text-white">Tiempo Demora</th>
                <th className="bg-color-softblue text-white">Emisor</th>
                <th className="bg-color-softblue text-white">Origen</th>
                <th className="bg-color-softblue text-white">Destino</th>
                <th className="bg-color-blue text-white">Guías</th>
                <th className="bg-color-blue text-white">Importe MX</th>
                <th className="bg-color-blue text-white">Kgs Fac</th>
                <th className="bg-color-blue text-white rounded-table-right">Tarifa</th>
              </tr>
            </thead>
            <tbody id="main-data"></tbody>
          </table>
          {!hasMore && data.length > 0 && <p className="text-center">Fin de los registros</p>}
        </div>
      </div>
    </div>
  );
}

export default Detalles;